import { render, staticRenderFns } from "./clientlogin.vue?vue&type=template&id=c9356c5e&scoped=true"
import script from "./clientlogin.vue?vue&type=script&lang=js"
export * from "./clientlogin.vue?vue&type=script&lang=js"
import style0 from "./clientlogin.vue?vue&type=style&index=0&id=c9356c5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9356c5e",
  null
  
)

export default component.exports